import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import ChartFrame from "../charts/ChartFrame";
import { formatCount } from "../charts/format";

// Um funil por passos (spec do redesign, R4.3): a contagem de cada passo e, entre cada par, a passagem em
// destaque com uma frase curta (`rate`, ja formatada, e `rateLabel`). Um passo sem `rate` nao tem
// passagem: o primeiro, ou uma passagem que quem monta os passos decidiu nao mostrar.
// A coluna das passagens na tabela diz por omissao "do passo anterior"; `rateColumn` da-lhe outro nome
// quando as passagens sao outra coisa (por exemplo "por 100 cartoes").
// A coluna das passagens fica fora do ficheiro de "Descarregar esta tabela": sao taxas ja formatadas, e as
// taxas tiram-se das contagens.
const StepFunnel = ({ title, steps, note, info, rateColumn }) => {
  const { translate, language } = useLanguage();
  const table = {
    columns: [
      { key: "label", label: translate("analyticsCategory") },
      { key: "value", label: translate("analyticsCount"), numeric: true, format: (value) => formatCount(value, language) },
      { key: "rate", label: rateColumn || translate("analyticsFunnelRateColumn"), numeric: true, skipInDownload: true },
    ],
    rows: steps.map((step) => ({ key: step.key, label: step.label, value: step.value, rate: step.rate || "" })),
  };
  return (
    <ChartFrame title={title} note={note} info={info} table={table}>
      <ol className="flex flex-col sm:flex-row sm:items-stretch gap-2">
        {steps.map((step) => (
          <li key={step.key} className="flex flex-col sm:flex-row sm:items-center gap-2 flex-1 min-w-0">
            {step.rate && (
              <span className="self-start sm:self-auto rounded-lg px-2.5 py-1 text-center" style={{ backgroundColor: "var(--color-surface-raised)", color: "var(--color-text-primary)" }}>
                <strong className="block text-sm tabular-nums">{step.rate}</strong>
                <span className="text-xs" style={{ color: "var(--color-text-secondary)" }}>
                  {step.rateLabel}
                </span>
              </span>
            )}
            <div className="flex-1 rounded-lg p-3" style={{ backgroundColor: "var(--color-surface-raised)" }}>
              <p className="text-xs" style={{ color: "var(--color-text-secondary)" }}>
                {step.label}
              </p>
              <p className="text-xl font-semibold tabular-nums" style={{ color: "var(--color-text-primary)" }}>
                {formatCount(step.value, language)}
              </p>
            </div>
          </li>
        ))}
      </ol>
    </ChartFrame>
  );
};

export default StepFunnel;
